module.exports = __webpack_public_path__ + "img/113018.06aa7607.png";